module.exports = __webpack_public_path__ + "static/media/comfort.e9ee0378.png";